import React from 'react';

const LeptIcon = () => <span style={{ fontFamily: 'meritodynamics-icons' }}>lept-circle-inverted</span>;
const MeritIcon = () => <span style={{ fontFamily: 'meritodynamics-icons' }}>merit-circle-inverted</span>;

export { LeptIcon, MeritIcon };
